var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWeight(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1L1.476 2.428C1.714 3.14287 2.38337 3.625 3.13675 3.625H7.125V5.445C4.15788 5.87025 1.875 8.41475 1.875 11.5V14.125C1.875 14.608 2.267 15 2.75 15H13.25C13.733 15 14.125 14.608 14.125 14.125V11.5C14.125 8.41475 11.8421 5.87025 8.875 5.445V3.625H12.8632C13.6166 3.625 14.2851 3.14287 14.5231 2.428L15 1H1ZM9.75 10.625C9.75 11.5919 8.96688 12.375 8 12.375C7.03312 12.375 6.25 11.5919 6.25 10.625C6.25 9.65812 7.03312 8.875 8 8.875C8.96688 8.875 9.75 9.65812 9.75 10.625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeight);
export default __webpack_public_path__ + "static/media/weight.02ebd25657e161dcb79ddbc565d728fa.svg";
export { ForwardRef as ReactComponent };